module.exports = __webpack_public_path__ + "static/img/bg-1.62e5e62d.png";